import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { ProductClickProvider } from "../../ecommerce/products/hooks/index.js";
import { TicketItem } from "../../events/components/TicketItem.jsx";
import { InstructionTitle } from '../../../components/ui/typography/InstructionTitle.jsx';
import ImpactTitle from '../../../components/ui/typography/ImpactTitle.jsx';
import {extractColorCodeFromCssVariable} from "../../themes/js/utils.js";

const CollectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: 20px auto;
`;

const CategoryButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const CategoryButton = styled.button`
  background: ${props => props.active ? `white` : 'transparent'};
  color: ${props => props.active ? 'black' : 'var(--text-colour)'};
  border: ${props => props.active ? 'none' : `1px solid ${extractColorCodeFromCssVariable('--accent-colour')}`};
  border-radius: var(--border-radius-default);
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  padding: 8px 16px;
  height: 40px;
  width: 100px;
  font-size: 14px;
  text-transform: capitalize; // Change this to uppercase text
  cursor: pointer;
  transition: all 0.3s ease;

`;

const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

/**
 * @param {object} data - The data object containing the product list.
 * @param {function} onClickFunction - The function to be called when a product is clicked.
 * @param {array} selectedList - The list of selected products.
 * @returns {JSX.Element} - The ProductCollection component.
 */

const ProductCollection = ({ data, onClickFunction, selectedList }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);

  console.log('productCollection', data)


  useEffect(() => {
    if (data && data.product_list) {
      const categoryList = Object.keys(data.product_list);
      setCategories(categoryList);
      setSelectedCategory(categoryList[0]);
    }
  }, [data]);

  useEffect(() => {
    if (selectedCategory && data && data.product_list) {
      const sortedProducts = [...data.product_list[selectedCategory]].sort((a, b) => b.price - a.price);
      setProducts(sortedProducts);
    }
  }, [selectedCategory, data]);

  return (
    <CollectionContainer>
      {categories.length > 1 && (
        <CategoryButtonContainer>
          {categories.map((category) => (
            <CategoryButton
              key={category}
              active={category === selectedCategory}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </CategoryButton>
          ))}
        </CategoryButtonContainer>
      )}
      {/* <ImpactTitle header={'Deliverables'} /> */}
      <ProductListContainer>
        {products.map((item, index) => {

          const isSelected = selectedList?.includes(item);
          return (
            <ProductClickProvider key={index} item={item}>
              <TicketItem item={item} onClickFunction={onClickFunction} style={{background: isSelected ? 'var(--success-colour)' : null}} />
            </ProductClickProvider>
          )
        })}
      </ProductListContainer>
    </CollectionContainer>
  );
};

ProductCollection.propTypes = {
  data: PropTypes.shape({
    product_list: PropTypes.object.isRequired,
  }).isRequired,
};

export default ProductCollection;
